(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }
        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }
                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
class StickyHeaderMobile extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.header = document.querySelector('.section-header-mobile');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
        if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        };
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
    }
    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });
        observer.observe(this.header);
    }
    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);
    
                this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
                }, 66);
                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
    }
    hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.header.style.top = '';
    }
    reveal() {
        const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        if (headerMultiSite) {
            const height = headerMultiSite.offsetHeight;
            this.header.style.top = `${height}px`;
        }
    }
    reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        this.header.style.top = '';
    }
}
customElements.define('sticky-header-mobile', StickyHeaderMobile);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      
      if (window.innerWidth <= 1024) {
          var $filterBar = $('.collection-filter-bar');
          if ($filterBar.length) {
              $filterBar.css('top', '0px');
          }
          $('body').removeClass('sticky-filter-added');
      }

      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      document.querySelector('body').classList.add('sticky-header-enabled');
      
        var closeButton = document.querySelector('.search-modal__close-button');
        if (closeButton) {
          closeButton.click();
          var element = document.querySelector('.snize-ac-results.snize-new-design');
          if (element) {
            element.style.display = 'none';
          }
        }

      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      
      if (window.innerWidth <= 1024) {
          var $filterBarAdded = $('.collection-filter-bar');
          if ($filterBarAdded.length) {
              $filterBarAdded.css('top', '68px');
          }
          $('body').addClass('sticky-filter-added');
      }

      this.header.classList.add('scrolled-past-header');
       document.querySelector('body').classList.add('sticky-header-enabled');
     
      var closeButton = document.querySelector('.snize-input-style');
        if (closeButton) {
          closeButton.click();
          var element = document.querySelector('.snize-ac-results.snize-new-design');
          if (element) {
            element.style.display = 'none';
          }
        }
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
        if (!document.querySelector('body').classList.contains('dspg-page-aw24-home') || !document.querySelector('body').classList.contains('template-index')) {
      this.header.classList.remove('scrolled-past-header');
       document.querySelector('body').classList.remove('sticky-header-enabled');
        }
      var closeButton = document.querySelector('.search-modal__close-button');
        if (closeButton) {
          closeButton.click();
          var element = document.querySelector('.snize-ac-results.snize-new-design');
          if (element) {
            element.style.display = 'none';
          }
        }
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}
customElements.define('sticky-header', StickyHeader);
// document.querySelector('.none-icon').style.display = '';
// $('.menu-lv-item.menu-lv-1').hover(
//     function() {
//         if (!$(this).closest('.scrolled-past-header').length) {
//             $('.header-single-line--transparent, .header-plain--transparent').addClass('white-bg-added');
//             $('.header-single-line .header__icon .icon').addClass('icon-black');
//             $('.dropdown-toggle .text').addClass('color-black');
//             $('.dropdown-toggle').addClass('color-black');
//         }
//     },
//     function() {
//         if (!$(this).closest('.scrolled-past-header').length) {
//             $('.header-single-line--transparent, .header-plain--transparent').removeClass('white-bg-added');
//           $('.header-single-line .header__icon .icon').removeClass('icon-black');
//           $('.dropdown-toggle .text').removeClass('color-black');
//             $('.dropdown-toggle').removeClass('color-black');
//         }
//     }
// );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header-navigation');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
      if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky');
              return
          } else {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
              this.header.classList.remove('shopify-section-header-show');
          }
          if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
              $('.vertical-menu').addClass('vertical-menu__hide');
          }
      }
    this.closeMenuDisclosure();
  }
  reveal() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }
      }
  }
  reset() {
      if (this.headerIsAlwaysSticky != null) {
        if (this.headerIsAlwaysSticky === 'always') {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              return
          } else {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
        }
        if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
            if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
              $('.vertical-menu').removeClass('vertical-menu__hide');
            }
        }
      }
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-test-backup-11-sep-24"]) return;
  try {
    
                                            
var urlParams = new URLSearchParams(window.location.search);

// Retrieve a specific parameter value by its name
var customerIdParam = urlParams.get('customer_id');
var orderIDParam = urlParams.get('order_id');
var typeParam = urlParams.get('type');
console.log(customerIdParam);
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });


    let dataSet=[];
    let orderID=null,customerID=null;
    let selectOption = 'phone';
    $('#tableConfirmation').hide();
    $('.spinner-border').hide();
    function changeSearchBy(element){
        if(element.value==="phone_number"){
            document.getElementById("input-search-label").innerHTML="Mobile";
            document.getElementById("input-search").type="text";
        }else{
            document.getElementById("input-search-label").innerHTML="Email";
            document.getElementById("input-search").type="email";
        }
    }
    $('.nav-link').click(function(){
        var activeTab = $(this).data('type');
        $('#tabData').val(activeTab);
        $("#search-btn").click();
    });
    function responseCardLoad(){
      
        var SelectSize = '';
        $('.error').hide();
        $('.type-error').hide();
        $('.specific-reason').hide();
        $('.checkbox').change(function () {
            // let parent=$(this).parent();
            let parent=$(this).closest('.flex-row-reverse');
            var lineItemId = $(this).data('lineItemId');
            // if(this.checked){
            //     parent.parent().addClass('selected-card');
            //     elementAction(true,$(this).data('lineItemId'));
            // }else{
            //     parent.parent().removeClass('selected-card');
            //     elementAction(false,$(this).data('lineItemId'));
            // }
          selectCard(this.checked, lineItemId, parent);
      });

      function selectCard(checked, lineItemId, parent) {
            if(checked){
                parent.parent().addClass('selected-card');
                elementAction(true, lineItemId);
            }else{
                parent.parent().removeClass('selected-card');
                elementAction(false, lineItemId);
            }
        }

        $('.quantity').change(function () {

            if(parseInt($(this).val())===0)
                $(this).val('');

            $(`.type-error[data-line-item-id="${$(this).data("lineItemId")}"]`).hide();
            if($(this).val()>parseInt($(this).data('maxQty'))){
                $(this).val('');
                $(`.type-error[data-line-item-id="${$(this).data("lineItemId")}"]`).show();
            }

        });

       function checkSelectedValues(selectElement) {
              var selectedValues = $(selectElement).val();
              if (selectedValues && (selectedValues.includes('4') || selectedValues.includes('6'))) {
                  $('#TooBigTooLongPopup').show();
              } else {
                  $('#TooBigTooLongPopup').hide();
              }
          }
        
        $('.reason').change(function () {
          let parent = $(this).closest('.card');
            let checkBoxDiv = parent.find('.flex-row-reverse');
            checkBoxDiv.find('.checkbox').prop('checked', true);
            selectCard(true, $(this).data("lineItemId"), checkBoxDiv);
  
            if($(this).children("option:selected").text()==="Other"){
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).show();
            }else {
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).hide();
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('');
            }
        });

        $('.reason[data-brand="Goddiva"], .reason[data-brand="Goddiva Plus"], .reason[data-brand="City Goddess"], .reason[data-brand="Cosmochic"], .reason[data-brand="Danaya"]').change(function () {
            checkSelectedValues(this);
        });
      
        $('.available_option').change(function () {
            var SelectSize = $(this).children("option:selected").text();
            var itemSize = $(this).data("size");

          let parent = $(this).closest('.card');
            let checkBoxDiv = parent.find('.flex-row-reverse');
            checkBoxDiv.find('.checkbox').prop('checked', true);
            selectCard(true, $(this).data("lineItemId"), checkBoxDiv);

            $(`.is_same_size[data-line-item-id="${$(this).data("lineItemId")}"]`).val(SelectSize === itemSize);

            $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).hide();
            $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('');
            $(`.exchange-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).prop('disabled', false);
            $(`.exchange-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('');

            if (SelectSize === itemSize) {
                $(`.exchange-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('Other');
                $(`.exchange-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).prop('disabled', true);
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).show();
            }
        });

        $('.exchange-reason').change(function () {
            if($(this).children("option:selected").text()==="Other"){
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).show();
            }else {
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).hide();
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('');
            }
        });
        console.log(SelectSize);
        
    }
    $("#search-btn").click(function(e) {
        e.preventDefault();
       e.stopPropagation();
    
        var $email = $('.email').val();
        var $phone = $('.phone_number').val();
        var $orderId = $('.orderId').val();
        var $tabData = $('#tabData').val();

        $('.email-msg').removeClass('invalid-msg');
        $('.phone-msg').removeClass('invalid-msg');
        $('#responseCard').hide();

        if(selectOption == 'phone') {
            if ($phone == '') {
                $('.phone-msg').addClass('invalid-msg').text("Phone is required");
                $('.phone_number').addClass('invalid-input');
            }else{
                if($phone.match(/^[0-9]{4,11}$/) == null){
                    $('.phone-msg').addClass('invalid-msg').text("Invalid Phone Number");
                    $('.phone_number').addClass('invalid-input');
                }else{
                    $('.phone_number').removeClass('invalid-input');
                    $('.phone-msg').removeClass('invalid-msg').text("");
                }
            }
        }else{
            if ($email == '') {
                $('.email-msg').addClass('invalid-msg').text("Email is required");
                $('.email').addClass('invalid-input');
            }else{
                var mailformat = /\S+@\S+\.\S+/;
                if($email.match(mailformat) == null){
                    $('.email-msg').addClass('invalid-msg').text("Invalid Email");
                    $('.email').addClass('invalid-input');
                }else{
                    $('.email').removeClass('invalid-input');
                    $('.email-msg').removeClass('invalid-msg').text("");
                }

            }
        }

        if ($orderId == '') {
                $('.order-msg').addClass('invalid-msg').text("Order Id is required");
                $('.orderId').addClass('invalid-input');
            }else{
                $('.orderId').removeClass('invalid-input');
                $('.order-msg').removeClass('invalid-msg').text("");
            }

       if (($phone.length > 0 || $email.length > 0) && $orderId.length > 0) {
            $('#resultsBody').html('');
            $('#resultsBodyExchange').html('');
            $('#responseBody').hide();
            $('.spinner-border').show();
            $('.search').prop('disabled',true);

          $('.loader').show();
            var form = $(this);
            var actionUrl = form.attr('action');

            $.ajax({
                type: "POST",
                url: "https://mp.mygoddiva.com/v1/order/return-request/search",
                data: {
                    _token: "{{ csrf_token() }}",
                    order_id:$orderId,
                    search_type: $phone?'phone_number':'email',
                    input_search: $phone?$phone:$email,
                    type: $tabData
                }, // serializes the form's elements.
                success: function(data) {
                    $('.loader').hide();
                    $('.search').prop('disabled',false);
                    $('.spinner-border').hide();
                    if(data.error){
                        // responseMessage(1,data.message);
                        toastr.warning(data.message);
                        $('.search').prop('disabled',false);
                    }else{
                        if($tabData == 'return'){
                            $('#resultsBody').show();
                            $('#resultsBody').html(data);
                        }else{
                            $('#resultsBodyExchange').show();
                            $('#resultsBodyExchange').html(data);
                        }

                        $('#responseCard').show();

                        responseCardLoad();
                    }
                    $('.search').prop('disabled',false);

                }
            });
       }

    });

    function elementAction(state,id) {
        $('.reason').each(function (e) {
            if($(this).data('lineItemId')===id)
                if(state){
                    $(this).prop('disabled', false);
                }else{
                    $(this).prop('disabled', true);
                    $(this).val('-1');
                }
        });

        $('.available_option').each(function (e) {
            if($(this).data('lineItemId')===id)
                if(state){
                    $(this).prop('disabled', false);
                }else{
                    $(this).prop('disabled', true);
                    $(this).val('-1');
                }
        });

        $('.exchange-reason').each(function (e) {
            if($(this).data('lineItemId')===id)
                if(state){
                    $(this).prop('disabled', false);
                }else{
                    $(this).prop('disabled', true);
                    $(this).val('-1');
                }
        });

        $('.quantity').each(function (e) {
            if($(this).data('lineItemId')===id)
                if(state){
                    $(this).prop('disabled', false);
                }else{
                    $(this).prop('disabled', true);
                    $(this).val('');
                }
        });
    }

  $(document).ready(function() {
    $(document).on("click",".btn-submit",function() {
        // alert("click bound to document listening for #test-element");
      var orderID = $(this).data('order');
      var customerID = $(this).data('customer');
      var discountValue = $(this).data('discount_value');
      var btnType = $(this).data('type');
      console.log('btnType', btnType);
      console.log(orderID, customerID);
        $('.error').hide();
        $('#responseBody').hide();
        // $('#responseCard').hide();
        $('#mainError').fadeOut(500);
        let dataArray=[],isSameSizeArray=[],reasonArray=[],quantityArray=[],itemArray=[],specificReasonArray=[],variantArray=[],exchnageReasonArray=[],availableArray=[],errorFound=0,required=0,id=null;
        $('.reason').each(function (e) {
            reasonArray.push($(this).val());
            itemArray.push({id:$(this).data('lineItemId'),product:$(this).data('product'),reasonText:$(this).find('option:selected').text()})
        });
        if (btnType !== 'return') {
            $('.exchange-reason').each(function (e) {
                reasonArray.push($(this).val());
                itemArray.push({id:$(this).data('lineItemId'),product:$(this).data('product'),reasonText:$(this).find('option:selected').text()})
            });
        }
        $('.available_option').each(function (e) {
            availableArray.push($(this).val());
            var selectedOption = $(this).find('option:selected');
            var dataValue = selectedOption.data('variant-id');
            variantArray.push(dataValue);
        });

        $('.quantity').each(function (e) {
            quantityArray.push($(this).val());
        });

        $('.is_same_size').each(function (e) {
            isSameSizeArray.push($(this).val());
        });

        $('.specific-reason').each(function (e) {
            specificReasonArray.push($(this).val());
        });
        console.log(availableArray, quantityArray);
        $('.checkbox').each(function (index,element) {
            id=$(this).data('lineItemId');
            if(this.checked){
            // console.log(availableArray[index], reasonArray[index]);

                if (reasonArray[index]==undefined || reasonArray[index]==null) {
                        console.log('f');
                    required ++;
                }

                if (quantityArray[index]==undefined || quantityArray[index]==null || quantityArray[index]=='') {
                    required ++;
                }

                if (btnType !== 'return'){
                    if (availableArray[index]==undefined || availableArray[index]==null) {
                        required ++;
                        console.log('gg');
                    }

                    if (reasonArray[index]=='Other' &&  isSameSizeArray[index] && (specificReasonArray[index] == null || specificReasonArray[index]=='')) {
                        required ++;
                        console.log('hii');
                    }
                }

                if (required === 0 ) {
                    dataArray.push({
                        id:itemArray[index].id,
                        product:itemArray[index].product,
                        reasonText:itemArray[index].reasonText,
                        reason: reasonArray[index],
                        specificReasonArray: specificReasonArray[index],
                        exchnageReasonArray: exchnageReasonArray[index],
                        quantity:quantityArray[index],
                        availableArray:availableArray[index],
                        variant:variantArray[index]
                    });
                }else{
                    errorFound++;
                    $('.error').each(function (e) {
                        if($(this).data('lineItemId')===id)
                            $(this).show();
                    });
                }
            }
        });

        if(errorFound===0){
            $('#table > tbody').html('')
            var comfirm  = null;
            let tableRows=null;
            if(dataArray.length>0){
                dataSet=dataArray;
                dataArray.forEach(function (value,index) {
                    tableRows+=`<tr><td>${value.product}</td><td>${value.reasonText}</td><td>${value.quantity}</td>`;

                });
                $('#table > tbody').html(tableRows);
                // $('#resultsBody').fadeOut(500);

                if (btnType == 'return') {
                  
                    if (!comfirm) {
                            comfirm  = $.confirm({
                            title: 'Return Items',
                            closeIcon: true,
                            offsetTop:20,
                            content: 'Are you sure?',
                            buttons: {
                                confirm: {
                                    text: 'Yes',
                                    btnClass: 'btn-dark',
                                    action: function () {
                                        submitData(btnType, orderID, customerID);
                                    }
                                },
                                somethingElse: {
                                    text: 'No',
                                    btnClass: 'btn-dark no'
                                    //action: function(){
                                      //  submitData('keep', orderID, customerID);
                                        // $.alert({
                                        //     type: 'success',
                                        //     title: 'Success Item',
                                        //     content: 'Thank you for choosing to keep the item. We have sent you an email with the Gift Voucher, Happy Shopping!',
                                        // });
                                   // }
                                }
                            }
                        });
                    }
                    comfirm.open();

                } else {
                    comfirm  = $.confirm({
                        title: 'Exchange Items',
                        closeIcon: true,
                        content: 'Please confirm before proceeding request',
                        offsetTop:20,
                        buttons: {
                            confirm: {
                                text: 'Exchange',
                                btnClass: 'btn-dark',
                                action: function () {
                                    submitData(btnType, orderID, customerID);
                                }
                            },
                            cancel: function () {

                            }
                        }
                    });

                  
                }


            }else{
                // responseMessage(1,"Please select an item to proceed");
                toastr.warning("Please select an item to proceed");

            }
        }else{
            toastr.warning("Failed to proceed, please fill all required fields");
            // responseMessage(1,"Failed to proceed, please fill all required fields");
        }
     });
  });

    function removeConfirmTableItem(index){
        dataSet.splice(index,1);
    }

    function back() {
        $('#resultsBody').fadeIn(500);
        $('#tableConfirmation').fadeOut(500);
    }

    function submitData(type, orderID, customerID) {
        const data={
            _token: "{{ csrf_token() }}",
            items:dataSet,
            order:orderID,
            customer:customerID,
            type:type
        };
        console.log(data);

        $.ajax({
            type: "POST",
            url: 'https://mp.mygoddiva.com/v1/order/return-request/add',
            data, // serializes the form's elements.
            success: function(response) {
                if(response.error){
                    // responseMessage(1,response.message);
                    toastr.warning(response.message);
                }else{
                    // responseMessage(2,response.message);
                    // $('#resultsBody').hide();
                    // $('#tableConfirmation').hide();
                    $.alert({
                        type: 'success',
                        title: 'Success Item',
                        content: response.message,
                    });
                    
                  if(customerIdParam && orderIDParam){
                    
                      setTimeout(function() {
                        location.reload();
                      }, 5000);
                  }else{
                    $("#search-btn").click();
                  }
                }
            }
        });

    }

    function responseMessage(action,message) {
        $('#responseBody').show();
        let responseSet=null;
        if(action===1){
            responseSet=`<div class="mt-2 alert alert-danger d-flex alert-dismissible align-items-center fade show" role="alert">
                        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg>
                        <div>${message}</div><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`
        }else if(action===2){
            responseSet=`<div class="mt-2 alert alert-success d-flex align-items-center alert-dismissible fade show" role="alert">
                <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg>
                <div>${message}</div><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`
        }
        $('#responseBody').html(responseSet);
    }

    $('#search_type').change(function() {
      selectOption = this.value;
        if(this.value == "phone"){
            $('.email_div').hide();
            $('.phone_div').show();
            $('.email').val('');
        }else{
            $('.phone_div').hide();
            $('.email_div').show();
            $('.phone_number').val('');
        }
    })

    document.addEventListener('DOMContentLoaded', function() {
    $('#resultsBody').html('');
    $('#resultsBodyExchange').html('');
    $('#customerResponseBody').html('');
    $('#responseBody').hide();
    
    if(customerIdParam && orderIDParam){
      $('.loader').show();
       $.ajax({
            type: "GET",
            url: 'https://mp.mygoddiva.com/v1/order/get-order?order_id='+ orderIDParam +'&customer='+ customerIdParam+'&type='+typeParam,
            data: {
                _token: "{{ csrf_token() }}",
                order_id: orderIDParam,
                customer: customerIdParam,
                type:typeParam
            }, // serializes the form's elements.
            success: function(data) {
              $('.loader').hide();
                if(data.error){
                    // responseMessage(1,data.message);
                    toastr.warning(data.message);
                }else{
                    $('#customerResponseBody').show();
                    $('#customerResponseBody').html(data);
                    responseCardLoad();
                }

            }
        });
    }
   
  });
  



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-test"]) return;
  try {
    
                                            
var urlParams = new URLSearchParams(window.location.search);

// Retrieve a specific parameter value by its name
var customerIdParam = urlParams.get('customer_id');
var orderIDParam = urlParams.get('order_id');
var typeParam = urlParams.get('type');
console.log(customerIdParam);
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });


    let dataSet=[];
    let orderID=null,customerID=null;
    let selectOption = 'phone';
    $('#tableConfirmation').hide();
    $('.spinner-border').hide();
    function changeSearchBy(element){
        if(element.value==="phone_number"){
            document.getElementById("input-search-label").innerHTML="Mobile";
            document.getElementById("input-search").type="text";
        }else{
            document.getElementById("input-search-label").innerHTML="Email";
            document.getElementById("input-search").type="email";
        }
    }
    $('.nav-link').click(function(){
        var activeTab = $(this).data('type');
        $('#tabData').val(activeTab);
        $("#search-btn").click();
    });
    function responseCardLoad(){
      
        var SelectSize = '';
        $('.error').hide();
        $('.type-error').hide();
        $('.specific-reason').hide();
        $('.checkbox').change(function () {
            // let parent=$(this).parent();
            let parent=$(this).closest('.flex-row-reverse');
            var lineItemId = $(this).data('lineItemId');
            // if(this.checked){
            //     parent.parent().addClass('selected-card');
            //     elementAction(true,$(this).data('lineItemId'));
            // }else{
            //     parent.parent().removeClass('selected-card');
            //     elementAction(false,$(this).data('lineItemId'));
            // }
          selectCard(this.checked, lineItemId, parent);
      });

      function selectCard(checked, lineItemId, parent) {
            if(checked){
                parent.parent().addClass('selected-card');
                elementAction(true, lineItemId);
            }else{
                parent.parent().removeClass('selected-card');
                elementAction(false, lineItemId);
            }
        }

        $('.quantity').change(function () {

            if(parseInt($(this).val())===0)
                $(this).val('');

            $(`.type-error[data-line-item-id="${$(this).data("lineItemId")}"]`).hide();
            if($(this).val()>parseInt($(this).data('maxQty'))){
                $(this).val('');
                $(`.type-error[data-line-item-id="${$(this).data("lineItemId")}"]`).show();
            }

        });

       function checkSelectedValues(selectElement) {
              var selectedValues = $(selectElement).val();
              if (selectedValues && (selectedValues.includes('4') || selectedValues.includes('6'))) {
                  $('#TooBigTooLongPopup').show();
              } else {
                  $('#TooBigTooLongPopup').hide();
              }
          }
        
        $('.reason').change(function () {
          let parent = $(this).closest('.card');
            let checkBoxDiv = parent.find('.flex-row-reverse');
            checkBoxDiv.find('.checkbox').prop('checked', true);
            selectCard(true, $(this).data("lineItemId"), checkBoxDiv);
  
            if($(this).children("option:selected").text()==="Other"){
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).show();
            }else {
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).hide();
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('');
            }
        });

        $('.reason[data-brand="Goddiva"], .reason[data-brand="Goddiva Plus"], .reason[data-brand="City Goddess"], .reason[data-brand="Cosmochic"], .reason[data-brand="Danaya"]').change(function () {
            checkSelectedValues(this);
        });
      
        $('.available_option').change(function () {
            var SelectSize = $(this).children("option:selected").text();
            var itemSize = $(this).data("size");

          let parent = $(this).closest('.card');
            let checkBoxDiv = parent.find('.flex-row-reverse');
            checkBoxDiv.find('.checkbox').prop('checked', true);
            selectCard(true, $(this).data("lineItemId"), checkBoxDiv);

            $(`.is_same_size[data-line-item-id="${$(this).data("lineItemId")}"]`).val(SelectSize === itemSize);

            $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).hide();
            $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('');
            $(`.exchange-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).prop('disabled', false);
            $(`.exchange-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('');

            if (SelectSize === itemSize) {
                $(`.exchange-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('Other');
                $(`.exchange-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).prop('disabled', true);
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).show();
            }
        });

        $('.exchange-reason').change(function () {
            if($(this).children("option:selected").text()==="Other"){
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).show();
            }else {
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).hide();
                $(`.specific-reason[data-line-item-id="${$(this).data("lineItemId")}"]`).val('');
            }
        });
        console.log(SelectSize);
        
    }
    $("#search-btn").click(function(e) {
        e.preventDefault();
       e.stopPropagation();
    
        var $email = $('.email').val();
        var $phone = $('.phone_number').val();
        var $orderId = $('.orderId').val();
        var $tabData = $('#tabData').val();

        $('.email-msg').removeClass('invalid-msg');
        $('.phone-msg').removeClass('invalid-msg');
        $('#responseCard').hide();

        if(selectOption == 'phone') {
            if ($phone == '') {
                $('.phone-msg').addClass('invalid-msg').text("Phone is required");
                $('.phone_number').addClass('invalid-input');
            }else{
                if($phone.match(/^[0-9]{4,11}$/) == null){
                    $('.phone-msg').addClass('invalid-msg').text("Invalid Phone Number");
                    $('.phone_number').addClass('invalid-input');
                }else{
                    $('.phone_number').removeClass('invalid-input');
                    $('.phone-msg').removeClass('invalid-msg').text("");
                }
            }
        }else{
            if ($email == '') {
                $('.email-msg').addClass('invalid-msg').text("Email is required");
                $('.email').addClass('invalid-input');
            }else{
                var mailformat = /\S+@\S+\.\S+/;
                if($email.match(mailformat) == null){
                    $('.email-msg').addClass('invalid-msg').text("Invalid Email");
                    $('.email').addClass('invalid-input');
                }else{
                    $('.email').removeClass('invalid-input');
                    $('.email-msg').removeClass('invalid-msg').text("");
                }

            }
        }

        if ($orderId == '') {
                $('.order-msg').addClass('invalid-msg').text("Order Id is required");
                $('.orderId').addClass('invalid-input');
            }else{
                $('.orderId').removeClass('invalid-input');
                $('.order-msg').removeClass('invalid-msg').text("");
            }

       if (($phone.length > 0 || $email.length > 0) && $orderId.length > 0) {
            $('#resultsBody').html('');
            $('#resultsBodyExchange').html('');
            $('#responseBody').hide();
            $('.spinner-border').show();
            $('.search').prop('disabled',true);

          $('.loader').show();
            var form = $(this);
            var actionUrl = form.attr('action');

            $.ajax({
                type: "POST",
                url: "https://mp.mygoddiva.com/v1/order/return-request/search",
                data: {
                    _token: "{{ csrf_token() }}",
                    order_id:$orderId,
                    search_type: $phone?'phone_number':'email',
                    input_search: $phone?$phone:$email,
                    type: $tabData
                }, // serializes the form's elements.
                success: function(data) {
                    $('.loader').hide();
                    $('.search').prop('disabled',false);
                    $('.spinner-border').hide();
                    if(data.error){
                        // responseMessage(1,data.message);
                        toastr.warning(data.message);
                        $('.search').prop('disabled',false);
                    }else{
                        if($tabData == 'return'){
                            $('#resultsBody').show();
                            $('#resultsBody').html(data);
                        }else{
                            $('#resultsBodyExchange').show();
                            $('#resultsBodyExchange').html(data);
                        }

                        $('#responseCard').show();

                        responseCardLoad();
                    }
                    $('.search').prop('disabled',false);

                }
            });
       }

    });

    function elementAction(state,id) {
        $('.reason').each(function (e) {
            if($(this).data('lineItemId')===id)
                if(state){
                    $(this).prop('disabled', false);
                }else{
                    $(this).prop('disabled', true);
                    $(this).val('-1');
                }
        });

        $('.available_option').each(function (e) {
            if($(this).data('lineItemId')===id)
                if(state){
                    $(this).prop('disabled', false);
                }else{
                    $(this).prop('disabled', true);
                    $(this).val('-1');
                }
        });

        $('.exchange-reason').each(function (e) {
            if($(this).data('lineItemId')===id)
                if(state){
                    $(this).prop('disabled', false);
                }else{
                    $(this).prop('disabled', true);
                    $(this).val('-1');
                }
        });

        $('.quantity').each(function (e) {
            if($(this).data('lineItemId')===id)
                if(state){
                    $(this).prop('disabled', false);
                }else{
                    $(this).prop('disabled', true);
                    $(this).val('');
                }
        });
    }

  $(document).ready(function() {
    $(document).on("click",".btn-submit",function() {
        // alert("click bound to document listening for #test-element");
      var orderID = $(this).data('order');
      var customerID = $(this).data('customer');
      var discountValue = $(this).data('discount_value');
      var btnType = $(this).data('type');
      console.log('btnType', btnType);
      console.log(orderID, customerID);
        $('.error').hide();
        $('#responseBody').hide();
        // $('#responseCard').hide();
        $('#mainError').fadeOut(500);
        let dataArray=[],isSameSizeArray=[],reasonArray=[],quantityArray=[],itemArray=[],specificReasonArray=[],variantArray=[],exchnageReasonArray=[],availableArray=[],errorFound=0,required=0,id=null;
        $('.reason').each(function (e) {
            reasonArray.push($(this).val());
            itemArray.push({id:$(this).data('lineItemId'),product:$(this).data('product'),reasonText:$(this).find('option:selected').text()})
        });
        if (btnType !== 'return') {
            $('.exchange-reason').each(function (e) {
                reasonArray.push($(this).val());
                itemArray.push({id:$(this).data('lineItemId'),product:$(this).data('product'),reasonText:$(this).find('option:selected').text()})
            });
        }
        $('.available_option').each(function (e) {
            availableArray.push($(this).val());
            var selectedOption = $(this).find('option:selected');
            var dataValue = selectedOption.data('variant-id');
            variantArray.push(dataValue);
        });

        $('.quantity').each(function (e) {
            quantityArray.push($(this).val());
        });

        $('.is_same_size').each(function (e) {
            isSameSizeArray.push($(this).val());
        });

        $('.specific-reason').each(function (e) {
            specificReasonArray.push($(this).val());
        });
        console.log(availableArray, quantityArray);
        $('.checkbox').each(function (index,element) {
            id=$(this).data('lineItemId');
            if(this.checked){
            // console.log(availableArray[index], reasonArray[index]);

                if (reasonArray[index]==undefined || reasonArray[index]==null) {
                        console.log('f');
                    required ++;
                }

                if (quantityArray[index]==undefined || quantityArray[index]==null || quantityArray[index]=='') {
                    required ++;
                }

                if (btnType !== 'return'){
                    if (availableArray[index]==undefined || availableArray[index]==null) {
                        required ++;
                        console.log('gg');
                    }

                    if (reasonArray[index]=='Other' &&  isSameSizeArray[index] && (specificReasonArray[index] == null || specificReasonArray[index]=='')) {
                        required ++;
                        console.log('hii');
                    }
                }

                if (required === 0 ) {
                    dataArray.push({
                        id:itemArray[index].id,
                        product:itemArray[index].product,
                        reasonText:itemArray[index].reasonText,
                        reason: reasonArray[index],
                        specificReasonArray: specificReasonArray[index],
                        exchnageReasonArray: exchnageReasonArray[index],
                        quantity:quantityArray[index],
                        availableArray:availableArray[index],
                        variant:variantArray[index]
                    });
                }else{
                    errorFound++;
                    $('.error').each(function (e) {
                        if($(this).data('lineItemId')===id)
                            $(this).show();
                    });
                }
            }
        });

        if(errorFound===0){
            $('#table > tbody').html('')
            var comfirm  = null;
            let tableRows=null;
            if(dataArray.length>0){
                dataSet=dataArray;
                dataArray.forEach(function (value,index) {
                    tableRows+=`<tr><td>${value.product}</td><td>${value.reasonText}</td><td>${value.quantity}</td>`;

                });
                $('#table > tbody').html(tableRows);
                // $('#resultsBody').fadeOut(500);

                if (btnType == 'return') {
                  
                    if (!comfirm) {
                            comfirm  = $.confirm({
                            title: 'Return Items',
                            closeIcon: true,
                            offsetTop:20,
                            content: 'Are you sure?',
                            buttons: {
                                confirm: {
                                    text: 'Yes',
                                    btnClass: 'btn-dark',
                                    action: function () {
                                        submitData(btnType, orderID, customerID);
                                    }
                                },
                                somethingElse: {
                                    text: 'No',
                                    btnClass: 'btn-dark no'
                                    //action: function(){
                                      //  submitData('keep', orderID, customerID);
                                        // $.alert({
                                        //     type: 'success',
                                        //     title: 'Success Item',
                                        //     content: 'Thank you for choosing to keep the item. We have sent you an email with the Gift Voucher, Happy Shopping!',
                                        // });
                                   // }
                                }
                            }
                        });
                    }
                    comfirm.open();

                } else {
                    comfirm  = $.confirm({
                        title: 'Exchange Items',
                        closeIcon: true,
                        content: 'Please confirm before proceeding request',
                        offsetTop:20,
                        buttons: {
                            confirm: {
                                text: 'Exchange',
                                btnClass: 'btn-dark',
                                action: function () {
                                    submitData(btnType, orderID, customerID);
                                }
                            },
                            cancel: function () {

                            }
                        }
                    });

                  
                }


            }else{
                // responseMessage(1,"Please select an item to proceed");
                toastr.warning("Please select an item to proceed");

            }
        }else{
            toastr.warning("Failed to proceed, please fill all required fields");
            // responseMessage(1,"Failed to proceed, please fill all required fields");
        }
     });
  });

    function removeConfirmTableItem(index){
        dataSet.splice(index,1);
    }

    function back() {
        $('#resultsBody').fadeIn(500);
        $('#tableConfirmation').fadeOut(500);
    }

    function submitData(type, orderID, customerID) {
        const data={
            _token: "{{ csrf_token() }}",
            items:dataSet,
            order:orderID,
            customer:customerID,
            type:type
        };
        console.log(data);

        $.ajax({
            type: "POST",
            url: 'https://mp.mygoddiva.com/v1/order/return-request/add',
            data, // serializes the form's elements.
            success: function(response) {
                if(response.error){
                    // responseMessage(1,response.message);
                    toastr.warning(response.message);
                }else{
                    // responseMessage(2,response.message);
                    // $('#resultsBody').hide();
                    // $('#tableConfirmation').hide();
                    $.alert({
                        type: 'success',
                        title: 'Success Item',
                        content: response.message,
                    });
                    
                  if(customerIdParam && orderIDParam){
                    
                      setTimeout(function() {
                        location.reload();
                      }, 5000);
                  }else{
                    $("#search-btn").click();
                  }
                }
            }
        });

    }

    function responseMessage(action,message) {
        $('#responseBody').show();
        let responseSet=null;
        if(action===1){
            responseSet=`<div class="mt-2 alert alert-danger d-flex alert-dismissible align-items-center fade show" role="alert">
                        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg>
                        <div>${message}</div><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`
        }else if(action===2){
            responseSet=`<div class="mt-2 alert alert-success d-flex align-items-center alert-dismissible fade show" role="alert">
                <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg>
                <div>${message}</div><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`
        }
        $('#responseBody').html(responseSet);
    }

    $('#search_type').change(function() {
      selectOption = this.value;
        if(this.value == "phone"){
            $('.email_div').hide();
            $('.phone_div').show();
            $('.email').val('');
        }else{
            $('.phone_div').hide();
            $('.email_div').show();
            $('.phone_number').val('');
        }
    })

    document.addEventListener('DOMContentLoaded', function() {
    $('#resultsBody').html('');
    $('#resultsBodyExchange').html('');
    $('#customerResponseBody').html('');
    $('#responseBody').hide();
    
    if(customerIdParam && orderIDParam){
      $('.loader').show();
       $.ajax({
            type: "GET",
            url: 'https://mp.mygoddiva.com/v1/order/get-order?order_id='+ orderIDParam +'&customer='+ customerIdParam+'&type='+typeParam,
            data: {
                _token: "{{ csrf_token() }}",
                order_id: orderIDParam,
                customer: customerIdParam,
                type:typeParam
            }, // serializes the form's elements.
            success: function(data) {
              $('.loader').hide();
                if(data.error){
                    // responseMessage(1,data.message);
                    toastr.warning(data.message);
                }else{
                    $('#customerResponseBody').show();
                    $('#customerResponseBody').html(data);
                    responseCardLoad();
                }

            }
        });
    }
   
  });
  



  } catch(e) { console.error(e); }
})();
})();
